import { watchEffect as t } from "vue";
import { env as i } from "./index551.js";
function v(e, n, o) {
  i.isServer || t((r) => {
    window.addEventListener(e, n, o), r(() => window.removeEventListener(e, n, o));
  });
}
export {
  v as useWindowEvent
};
